const initialState = {
    loginModalState: false,
    students: "",
    teachers: "",
    personnels: "",
    data:{
    start_longitude : null,
    start_latitude : null,
    end_longitude: null,
    end_latitude: null,
    start_address : null,
    end_address : null,
    image_name : null,
    size : null,
    value :null ,
    receiver_phone_number :null,
    receiver_name :null,
    start_details_address : null,
    end_details_address : null,
    details_parcel : null,
    weight:null
    },
    driverData:{
        start_longitude_courier : null, 
        start_latitude_courier : null,
        end_longitude_courier: null, 
        end_latitude_courier :  null
    },
    error:null,
    location:null

}
const mainReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_LOGIN_MODAL-STATE':
            return { ...state, loginModalState: action.value };
        case "SET_STUDENTS":
            return { ...state, students: action.value };
            case "SET_TEACHERS":
            return { ...state, teachers: action.value };
            case "SET_PERSONNELS":
            return { ...state, personnels: action.value };
            case "SET_DATA":
            return { ...state, data: action.value };
            case "SET_DRIVER_DATA":
            return { ...state, driverData: action.value };
            case "SET_ERROR":
            return { ...state, error: action.value };
            case "SET_LOCATION":
            return { ...state, location: action.value };
        default:
            return state;
    }
}
export default mainReducer
